import * as i0 from '@angular/core';
i0.ComponentFactory;
